import { ClientCreate } from './ClientCreate'
import { ClientEdit } from './ClientEdit'
import { ClientList } from './ClientList'
import { ClientShow } from './ClientShow'

export { ClientCreate, ClientEdit, ClientList, ClientShow }
